import { Select } from 'antd';
import { useMemo } from 'react';
import { IReportsPanel } from '../../../types/reports';
import AnalyticsLayout from '../Analytics/components/Layout/AnalyticsLayout';
import ReportsOnDemand from './components/metocean/ReportsOnDemand';
import ReportsPreprocessed from './components/preprocessed/ReportsPreprocessed';
import ReportsNavigation from './components/ReportsNavigation';
import { useReportsNavigation } from './hooks/useReportsNavigation';
import styles from './Reports.module.scss';

export default function ReportsPanel(props: IReportsPanel) {
  const {
    userInput,
    updateUserInput,
    datasets,
    coordinates,
    point,
    handleChangePoint,
    pointOption,
  } = props;

  const defaultDataset = useMemo(() => {
    const find =
      point?.downloadPage?.map((item) => ({
        key: item.radioKey,
        value: item.datasetId,
      })) ?? [];
    return find;
  }, [point?.downloadPage]);

  const { activeReport, availableReports, handleReportTypeChanged } =
    useReportsNavigation();

  return (
    <div className={styles.reports}>
      <AnalyticsLayout
        globalContent={
          <div className={styles.globalContentWrapper}>
            <div className={styles.pointLabel}>
              <span>Point</span>
            </div>
            <Select
              id='ReportsPanel-Select_point'
              className={styles.pointSelect}
              placeholder='Select point'
              onChange={handleChangePoint}
              options={pointOption}
              value={point}
              disabled={false}
            />
          </div>
        }
        removeTopSectionBorder
        navigationContent={
          <ReportsNavigation
            availableReports={availableReports}
            activeReport={activeReport}
            handleReportTypeChanged={handleReportTypeChanged}
          />
        }
      >
        {activeReport === 'metocean-conditions' && (
          <ReportsOnDemand
            datasets={datasets}
            userInput={userInput}
            updateUserInput={updateUserInput}
            defaultDataset={defaultDataset}
            point={point}
          />
        )}
        {activeReport === 'preprocessed-data' && (
          <ReportsPreprocessed
            defaultDataset={defaultDataset}
            coordinates={coordinates}
            datasets={datasets}
          />
        )}
      </AnalyticsLayout>
    </div>
  );
}
